import * as React from 'react'

import ResultsInfo from './resultsInfo'
import Suggestions from './suggestions'

interface IProps {
  location: any
  totalHits: number
  didYouMeanByTerms: any[]
  authorSuggestion: any
  seoMeta: any
  styles: any
  TagName: string
}

const SearchResultHeaders = (props: IProps) => {
  const {
    totalHits = 0,
    didYouMeanByTerms = [],
    authorSuggestion,
    seoMeta,
    styles
  } = props
  const shouldShowSeo = seoMeta && seoMeta.heading && totalHits > 0

  return (
    <div className={styles.mainContainer}>
      {shouldShowSeo && <ResultsInfo {...props} />}
      {didYouMeanByTerms.length || authorSuggestion ? (
        <Suggestions {...props} />
      ) : null}
    </div>
  )
}

export default SearchResultHeaders



// WEBPACK FOOTER //
// ./client/components/searchHeader/searchResultHeaders.tsx